export function ChatSidebarIcon({ ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" {...props}>
      <g id="Group_24489" data-name="Group 24489" transform="translate(-865 -172)">
        <g
          id="Rectangle_10299"
          data-name="Rectangle 10299"
          transform="translate(865 172)"
          fill="#fff"
          stroke="currentColor"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="24" height="24" stroke="none" />
          <rect x="0.5" y="0.5" width="23" height="23" fill="none" />
        </g>
        <path
          id="Path_50067"
          data-name="Path 50067"
          d="M2887.25,1395.5h.01m4.24,0h.01m4.24,0h.01m-4.26,8.5a8.5,8.5,0,1,0-8.5-8.5,8.328,8.328,0,0,0,.623,3.192,2.637,2.637,0,0,1,.132.368.677.677,0,0,1,.019.2,2,2,0,0,1-.038.34l-.567,3.362a1.306,1.306,0,0,0-.028.652.448.448,0,0,0,.246.246,1.3,1.3,0,0,0,.652-.028l3.362-.567a1.992,1.992,0,0,1,.34-.038.678.678,0,0,1,.2.019,2.671,2.671,0,0,1,.368.132A8.325,8.325,0,0,0,2891.5,1404Zm-3.778-8.5a.472.472,0,1,1-.472-.472A.468.468,0,0,1,2887.722,1395.5Zm4.25,0a.472.472,0,1,1-.472-.472A.468.468,0,0,1,2891.972,1395.5Zm4.25,0a.472.472,0,1,1-.472-.472A.468.468,0,0,1,2896.222,1395.5Z"
          transform="translate(-2014.5 -1211.5)"
          fill="rgba(0,0,0,0)"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.64"
        />
      </g>
    </svg>
  );
}
